import moment from "moment";

import {
  Button,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import conf from "config-dlm";
import ErrorChip from "components/utils/ErrorChip";
import LogsDialog from "./LogsDialog";
import SuccessChip from "components/utils/SuccessChip";
import EmptyTableRow from "./Empty";
import { Snapshot, ProjectConfigSchema } from "hooks/pavm/base";

const LogsRow = (props: {
  open: boolean;
  data: Snapshot["logs"];
  config: ProjectConfigSchema;
  updatedAt: string | Date | undefined;
}) => {
  const { open, config, data, updatedAt } = props;

  return (
    <TableRow
      sx={{
        bgcolor: (theme) =>
          theme.palette.mode === "light" ? "primary.light" : "primary.dark",
      }}
    >
      <TableCell colSpan={10}>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Table size="small" aria-label="logs">
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: "text.secondary" }}>
                  <b>Logs</b>
                </TableCell>

                {conf.COLUMNS.LOGS.map((column: string) => (
                  <TableCell key={column} align="right">
                    <b>{column}</b>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {data.length === 0 ? (
                <EmptyTableRow colSpan={5} type="logs" />
              ) : (
                data.map((log) => {
                  const { name, data: current, error } = log;
                  return (
                    <TableRow key={name} sx={conf.LAST_CHILD_NO_BORDER}>
                      <TableCell />

                      <TableCell component="th" scope="row" align="right">
                        {name.toLowerCase()}
                      </TableCell>

                      <TableCell align="right">
                        {!!current ? (
                          <SuccessChip size="small" label={"active"} />
                        ) : (
                          <ErrorChip
                            size="small"
                            label={"error"}
                            info={error}
                          />
                        )}
                      </TableCell>

                      <TableCell align="right">
                        {moment(updatedAt).fromNow()}
                      </TableCell>

                      <TableCell align="right">
                        <LogsDialog
                          name={name}
                          data={current} // data will be "latest until live"
                          config={config}
                          disabled={!current}
                          updatedAt={updatedAt}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default LogsRow;
